module.exports = __webpack_public_path__ + "static/img/jgzx.4305e851.png";